import { apiSlice } from "../stores/base/api-slice";
import { Appliance } from "../model/appliance";

const applianceEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAppliances: builder.query<Appliance[], string | undefined>({
      query: (search) => ({
        url: "/product/appliance/all",
        method: "GET",
        // params: { search },
      }),
      providesTags: ["ApplianceCategory"],
    }),
    
    addAppliance: builder.mutation<Appliance, FormData>({
      query: (formData) => ({
        url: "/product/appliance",
        method: "POST",
        body: formData,
        // Don't set Content-Type here as the browser will set it correctly with the boundary
      }),
      invalidatesTags: ["ApplianceCategory"],
    }),
    
    editAppliance: builder.mutation<Appliance, FormData>({
      query: (formData) => ({
        url: "/product/appliance",
        method: "PUT",
        body: formData,
        // Don't set Content-Type here as the browser will set it correctly with the boundary
      }),
      invalidatesTags: ["ApplianceCategory"],
    }),
    
    deleteAppliance: builder.mutation<void, string>({
      query: (id) => ({
        url: `/product/appliance/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ApplianceCategory"],
    }),
  }),
});

export const {
  useGetAppliancesQuery,
  useLazyGetAppliancesQuery,
  useAddApplianceMutation,
  useEditApplianceMutation,
  useDeleteApplianceMutation,
} = applianceEndpoints;

export const prepareApplianceFormData = (data: {
  name: string;
  power: string | number;
  icon: File;
  applianceCategoryId: string;
}): FormData => {
  const formData = new FormData();
  formData.append("name", data.name);
  formData.append("power", data.power.toString());
  formData.append("icon", data.icon);
  formData.append("applianceCategoryId", data.applianceCategoryId);
  return formData;
};

export const prepareEditApplianceFormData = async (data: {
  id: string;
  name: string;
  power: string | number;
  applianceCategoryId: string;
  iconEdited: boolean;
  iconUrl?: { url: string; name: string };
}): Promise<FormData> => {
  const formData = new FormData();
  formData.append("id", data.id);
  formData.append("name", data.name);
  formData.append("power", data.power.toString());
  formData.append("applianceCategoryId", data.applianceCategoryId);

  if (data.iconEdited && data.iconUrl) {
    const blob = await fetch(data.iconUrl.url).then(r => r.blob());
    const file = new File([blob], data.iconUrl.name, { type: blob.type });
    formData.append("icon", file, file.name);
  }

  return formData;
};